import styled from 'styled-components';
import type { LeadCard, AIPriority } from '../../../../Data/leads.dto';





export const formatBudget = (min: string | null, max?: string | null): string => {
  const fmt = (v: string | null) => {
    if (!v) return null;
    const n = parseFloat(v);
    if (n >= 100000) return `₹${(n / 100000).toFixed(1).replace(/\.0$/, '')}L`;
    if (n >= 1000)   return `₹${(n / 1000).toFixed(0)}K`;
    return `₹${n}`;
  };

  if (max === undefined) {
    return fmt(min) || '';
  }

  const a = fmt(min), b = fmt(max);
  if (a && b) {
    if (a === b) return a;
    return `${a}–${b}`;
  }
  return a || b || '';
};

export const formatPipelineValue = (val: string): string => {
  const n = parseFloat(val || '0');
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(1)}Cr`;
  if (n >= 100000)   return `₹${(n / 100000).toFixed(1).replace(/\.0$/, '')}L`;
  return `₹${(n / 1000).toFixed(0)}K`;
};

export const timeAgo = (dateStr: string): string => {
  const ms = Date.now() - new Date(dateStr).getTime();
  const days = Math.floor(ms / 86400000);
  if (days === 0) return 'Today';
  if (days === 1) return '1 day ago';
  return `${days} days ago`;
};

export const isStale = (dateStr: string): boolean =>
  Date.now() - new Date(dateStr).getTime() > 7 * 86400000;

export const formatEventDate = (d: string | null): string => {
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
};

export const formatScheduledAt = (d: string): string =>
  new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

export const PRIORITY_COLORS: Record<AIPriority, { bg: string; text: string }> = {
  P1: { bg: '#ef4444', text: '#fff' },
  P2: { bg: '#f97316', text: '#fff' },
  P3: { bg: '#708090', text: '#fff' },
};

export const PRIORITY_BG: Record<AIPriority, string> = {
  P1: 'linear-gradient(144deg,#ef4444,#b91c1c)',
  P2: 'linear-gradient(144deg,#f97316,#d97706)',
  P3: 'linear-gradient(144deg,#eab308,#ca8a04)',
};

export const COLUMN_VALUES = (leads: LeadCard[]): string => {
  const total = leads.reduce((sum, l) => {
    const val = parseFloat(l.budget_max || l.budget_min || '0');
    return sum + val;
  }, 0);
  return formatPipelineValue(String(total));
};





export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-out;
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 440px;
  padding: 24px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  font-family: 'Urbanist', sans-serif;
  animation: slideUp 0.2s ease-out;
  @keyframes slideUp {
    from { transform: translateY(20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
`;

export const ModalTitle = styled.h3`
  font-size: 18px;
  font-weight: 800;
  color: #111827;
  margin: 0 0 10px 0;
`;

export const ModalBody = styled.p`
  font-size: 14px;
  color: #4b5563;
  line-height: 1.5;
  margin: 0 0 24px 0;
`;

export const ModalActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
`;

export const ModalCancelBtn = styled.button`
  padding: 8px 16px;
  border-radius: 10px;
  border: 1.5px solid #e5e7eb;
  background: white;
  color: #374151;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s;
  &:hover { background: #f9fafb; }
`;

export const ModalConfirmBtn = styled.button`
  padding: 8px 18px;
  border-radius: 10px;
  border: none;
  background: linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%);
  color: white;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s;
  &:hover { opacity: 0.9; }
`;
